import moment from "moment/moment";
import firebase from "firebase/app";
import {EventsTypes} from "@/enums/EventsTypes";
import {serializer} from "@/api/shared/serializer";
import Loader from "@/components/loader/Loader.vue";

export default {
  name: "GalleryEventPictures",
  data() {
    return {
      picker: {
        start: false,
        end: false,
      },
      startDate: moment().subtract(1, 'month').toISOString().substring(0, 10),
      endDate: moment().toISOString().substring(0, 10),
      events: [],
      loading: true
    }
  },
  components: {
    Loader
  },
  computed: {
    facility() {
      return this.$store.state.facilityModule.selectedFacility;
    },
    formattedStartDate() {
      return moment(this.startDate).format(this.facility.dateFormat);
    },
    formattedEndDate() {
      return moment(this.endDate).format(this.facility.dateFormat);
    },
  },
  methods: {
    async updateGalleryEventPictures() {
      this.$store.commit("setEventPicturesTime", {
        start: this.startDate,
        end: this.endDate
      });

      await this.getGalleryEventPictures();
    },
    async getGalleryEventPictures() {
      const fromDate = moment(this.startDate).startOf('day').toDate()
      const toDate = moment(this.endDate).endOf("day").toDate()

      await firebase
        .firestore()
        .collection("calender")
        .where("facilityId", "==", this.facility.id)
        .where("isPublished", "==", true)
        .where("start", ">=", fromDate)
        .where("start", "<=", toDate)
        .where("type", "in", [EventsTypes.ConciergeRequest, EventsTypes.Concierge, EventsTypes.PremiumServices, EventsTypes.LifestylePrograms])
        .get()
        .then((querySnapshot) => {
          let events = serializer.querySnapshotToDocuments(querySnapshot);

          events = events.filter((x: any) => {
            if(x?.galleryPhotos && x?.galleryPhotos.length >= 1) {
              return x;
            }
          });

          events = events.sort((a: any, b: any) => moment(b.start.seconds * 1000).diff(moment(a.start.seconds * 1000)));

          this.events = events.map((x: any) => {
            return {
              id: x.id,
              name: x.name,
              start: moment(x.start.seconds * 1000).format("dddd, DD MMMM, YYYY"),
              galleryPhotos: x.galleryPhotos
            }
          })
        })
    },
    async getTimesParams() {
      const start = this.$store.state.galleryModule.eventPicturesTime.start;
      const end = this.$store.state.galleryModule.eventPicturesTime.end;

      if(start) {
        this.startDate = start;
      }

      if(end) {
        this.endDate = end;
      }
    }
  },
  async created() {
    await this.getTimesParams();
    await this.getGalleryEventPictures();
    this.loading = false;
  },
}